import React from 'react';

const MarqueeSectionS4 = () => {
    return (
        <section className="marquee-section-s3">
            <div className="marquee_container">
                <div className="marquee">
                    <h2><i className="ti-star"></i> <span>web design</span></h2>
                    <h2><i className="ti-star"></i> <span>startup</span></h2>
                    <h2><i className="ti-star"></i> <span>digital agency</span></h2>
                    <h2><i className="ti-star"></i> <span>branding</span></h2>
                </div>
                <div className="marquee">
                    <h2><i className="ti-star"></i> <span>web design</span></h2>
                    <h2><i className="ti-star"></i> <span>startup</span></h2>
                    <h2><i className="ti-star"></i> <span>digital agency</span></h2>
                    <h2><i className="ti-star"></i> <span>branding</span></h2>
                </div>
            </div>
        </section>
    );
};

export default MarqueeSectionS4;